<div class="component-container">

    <!-- ── Encabezado ─────────────────────────────────────── -->
    <app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>
    <div class="title title--chips">

        <!-- Indicador global de cuántos registros viven en los
             catálogos visibles. Se llena dinámicamente conforme van
             llegando los search() de cada catálogo. -->
        @if (state() === 'ready' && menuCards().length > 0) {
            <span class="total-chip" matTooltip="Total de registros en los catálogos visibles">
                <mat-icon>inventory_2</mat-icon>
                <b>{{ totalCount() }}</b>&nbsp;registros en total
            </span>
        }
    </div>

    <!-- ═════════════════════ ESTADOS ═════════════════════ -->
    @switch (state()) {

        @case ('loading') {
            <div class="state-container">
                <mat-spinner diameter="48"></mat-spinner>
                <p class="state-text">Cargando catálogos...</p>
            </div>
        }

        @case ('no-role') {
            <div class="state-container">
                <mat-icon class="state-icon warning">person_off</mat-icon>
                <h3>Sin rol asignado</h3>
                <p class="state-text">
                    Tu usuario no tiene un rol asignado. Contacta al administrador
                    del sistema.
                </p>
            </div>
        }

        @case ('empty') {
            <div class="state-container">
                <mat-icon class="state-icon warning">folder_off</mat-icon>
                <h3>Sin catálogos disponibles</h3>
                <p class="state-text">
                    Tu rol no tiene permiso para ver ningún catálogo. Si necesitas
                    acceso, contacta al administrador.
                </p>
            </div>
        }

        @case ('error') {
            <div class="state-container">
                <mat-icon class="state-icon danger">error_outline</mat-icon>
                <h3>Error al cargar</h3>
                <p class="state-text">
                    No se pudieron cargar los catálogos. Intenta refrescar la página.
                </p>
            </div>
        }

        @case ('ready') {
            <div class="menu-container">
                <div class="grid-menu">
                    @for (item of menuCards(); track item.route) {
                        <button
                            mat-button
                            color="primary"
                            class="menu-item-btn"
                            (click)="navigateTo(item.route)">
                            <div class="button-content">
                                <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>

                                <!-- Conteo de registros del catálogo. Solo aparece
                                     una vez resuelto el search; mientras tanto se
                                     muestra un placeholder discreto. -->
                                @if (countFor(item.route) !== undefined) {
                                    <span class="count-badge" matTooltip="Registros dados de alta">
                                        {{ countFor(item.route) }}
                                    </span>
                                } @else {
                                    <span class="count-badge count-badge--loading" matTooltip="Calculando...">
                                        …
                                    </span>
                                }

                                <span class="menu-label">{{ item.title }}</span>
                                <p class="menu-description">{{ item.description }}</p>
                            </div>
                        </button>
                    }
                </div>
            </div>
        }
    }
</div>
